import http from '@/util/http';
import httpJsonp from '@/util/httpJsonp';
import config from '../util/config';
import util from '../util';

export default {
	// 获取账号绑定的手机号
	checkMobileAuth: (mobile = '') => {
		let csrfToken = window.____global.csrfToken || '';
		return http.get(
			'//jianli.58.com/resumeapi/mobilestate?business=1&caller=1&mobile=' +
				mobile +
				'&csrfToken=' +
				csrfToken
		);
	},

	// 获取手机号验证码
	getCheckCode: mobile => {
		return http.get(
			'//jianli.58.com/resumecommon/getcaptcha?mobile=' +
				mobile +
				'&platform=3'
		);
	},

	// 验证手机号验证码
	verifyCheckCode: (mobile, checkCode, responseid) => {
		return http.get(
			'//jianli.58.com/resumecommon/checkcaptcha?mobile=' +
				mobile +
				'&code=' +
				checkCode +
				'&responseid=' +
				responseid
		);
	},

	// 获取地域接口
	getAreaInfo: cityname => {
		return http.get(
			'//jianli.58.com/resumecommon/city/zonebyname?cityname=' + cityname
		);
	},

	// 获取用户简历份数
	getResumeCount: userId => {
		return http.get(
			'//jianli.58.com/resumeapi/resumecount?userId=' + userId
		);
	},

	// 获取上一份简历信息接口
	getLastResumeInfo: () => {
		return http.get('//jianli.58.com/resumeapi/lastresumeinfo');
	},

	// 获取用户隐私设置接口
	getPrivacy: () => {
		return http.get(config.jlDomain + '/userprivacy/getprivacy');
	},

	// 上传图片
	uploadImg: dataUrl => {
		let paramObj = {
			'Pic-Size': '0*0',
			'Pic-Encoding': 'base64',
			'Pic-Path': '/nowater/jltx/',
			'Pic-Data': dataUrl
		};
		return http.post(
			'//upload.58cdn.com.cn/json?rand=' + Math.random(),
			JSON.stringify(paramObj),
			'text'
		);
	},

	// 获取动态的图片上传url
	getUploadUrl: () => {
		return http.get("//jianli.58.com/resumeupdatev2/pic/authentication?type=1");
	},

	// input头像上传
	uploadPic: ({ imgData, uploadUrl }) => {
		return httpJsonp.put(uploadUrl, imgData);
	},

	// 保存简历基本信息
	saveResume: params => {
		// 完整简历
		if (params.from === 3) {
			return http.post(
				config.jlDomain + '/resumepost/fulltime?isminiprogram=true',
				params,
				null,
				{ headers: { flowsrc: util.getParamVal('flowsrc') || 'public', } }
			);
		} else {
			return http.post(
				config.jlDomain + '/resumepost/micro?isminiprogram=true',
				params,
				null,
				{ headers: { flowsrc: util.getParamVal('flowsrc') || 'public', } }
			);
		}
	},

	// 隐私设置接口
	setPrivacy: params => {
		return http.post(config.jlDomain + '/userprivacy/postprivacy', params);
	},

	// 投递接口
	delivery: params => {
		return http.post(config.jlDomain + '/resumedelivery/process', params, null,
			{ headers: { flowsrc: util.getParamVal('flowsrc') || 'public', } });
	}
};



// WEBPACK FOOTER //
// ./src/module/basic/api/index.js